var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-container"},[_vm._v("You need to update the required information for the "),_c('b',[_vm._v("Stripe's Connect Account")]),_vm._v(".")])
}]

export { render, staticRenderFns }